import React, { useState, useRef, useEffect } from 'react';

const ApplyForInput = ({ value, onChangeApplyFor, label = 'Apply for:' }) => {
    const [applyFor, setApplyFor] = useState(value);
    const initialValueRef = useRef(value);

    useEffect(() => {
        setApplyFor(value);
        initialValueRef.current = value;
    }, [value]);

    const handleFocus = (v) => {
        initialValueRef.current = v;
    };

    const handleBlur = (v) => {
        if (initialValueRef.current !== v) {
            onChangeApplyFor(v);
        }
    };

    return (

        <div className="applyForInputContainer">
            <label className="applyForLabel">{label}</label>
            <div className="applyForInput">
                <input
                    type="number"
                    value={applyFor}
                    onChange={(e) => setApplyFor(e.target.value)}
                    onFocus={(e) => handleFocus(e.target.value)}
                    onBlur={(e) => handleBlur(e.target.value)}
                    className="applyForInputField"
                    min="1"
                />
                <div className="applyForInputAddon">
                    items
                </div>
            </div>
        </div>
    );
};

export default ApplyForInput;
